import React, { useState } from "react";
import { ref, child, get, getDatabase } from "firebase/database";
import GetAuth from "./GetAuth";

const UseData = () => {
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [data, setData] = useState();
	React.useEffect(() => {
		get(child(dbRef, "josettehill"))
			.then((snapshot) => {
				setData(snapshot.val());
			})
			.catch((error) => {
				console.log(error);
			});
	}, [dbRef]);
	return [data];
};

export default UseData;
